/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Events_Not_In_Team_Project_ConfirmInputs */



/**
* | output |
* | --- |
* | "OK" |
*
* @param {Team_Sync_Events_Not_In_Team_Project_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_events_not_in_team_project_confirm = /** @type {((inputs?: Team_Sync_Events_Not_In_Team_Project_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Events_Not_In_Team_Project_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("OK")
	if (locale === "de") return /** @type {LocalizedString} */ ("OK")
	if (locale === "it") return /** @type {LocalizedString} */ ("OK")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ХОРОШО")
	if (locale === "es") return /** @type {LocalizedString} */ ("DE ACUERDO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("好的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("わかりました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ठीक है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("OK")
	return /** @type {LocalizedString} */ ("OK")
});